import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StaffPermission } from '../constants/staff-roles';
import { PermissionService } from '../services/permission.service';

export function permissionGuard(permission: StaffPermission): CanActivateFn {
  return () => {
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    if (permissionService.hasPermission(permission)) {
      return true;
    }

    return router.createUrlTree(['/programs']);
  };
}
